import envSchema from "env-schema";
const schema = {
    type: 'object',
    required: [ 'VUE_APP_API_BASE_URL', 'VUE_APP_BASE_URL'],
    properties: {
        VUE_APP_RISK_LOW_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 30
        },
        VUE_APP_RISK_MEDIUM_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 69
        },
        VUE_APP_RISK_HIGH_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 100
        },
        VUE_APP_RISK_SCORE_TRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 55
        },
        // Path folding: an address with at least this many transactions is a
        // hub (a service), never folded as transit. 10 000 keeps busy wallets
        // (a few thousand transactions) as transit and stops at services.
        VUE_APP_FOLD_HUB_TX_COUNT: {
            type: 'number',
            minimum: 1,
            default: 10000
        },
        // Path folding: a longer gap between two hops of a folded path is
        // flagged as a long wait (the path is kept).
        VUE_APP_FOLD_MAX_PAUSE_DAYS: {
            type: 'number',
            minimum: 0,
            default: 30
        },
        VUE_APP_RISK_MEDIUM_DEFAULT: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 50
        },
        VUE_APP_FINENESS_POOR_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 50
        },
        VUE_APP_FINENESS_MEDIUM_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 75
        },
        VUE_APP_FINENESS_GOOD_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 95
        },
        VUE_APP_FINENESS_EXCELLENT_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 100
        },
        VUE_APP_TIMEOUT_MONITORING_LIST: {
            type: 'number' ,
            default: 30000
        },
        VUE_APP_TIMEOUT_MONITORING_SCORE: {
            type: 'number' ,
            default: 25000
        },
        VUE_APP_API_USERS_URL: {
            type: 'string',
            minLength: 2,
            maxLength: 128,
            default: 'https://dev1.glprotocol.com/api/'
        },
        VUE_APP_LABEL_API_URL: {
            type: 'string',
            minLength: 2,
            maxLength: 128,
            default: 'https://common.dev1.glprotocol.com/api-labeling/'
        },
        VUE_APP_WALLET_LABEL_API_URL: {
          type: 'string',
          minLength: 2,
          maxLength: 128,
          default: 'https://common.dev1.glprotocol.com/api-labeling/wallet-labeling'
        },
        VUE_APP_PROFILES_API_URL: {
          type: 'string',
          minLength: 2,
          maxLength: 128,
          default: 'https://common.dev1.glprotocol.com/api-labeling/profiles'
        },
        VUE_APP_BASELINE_API_URL: {
            type: 'string',
            minLength: 8,
            maxLength: 128,
            default: 'https://common.dev1.glprotocol.com/baseline'
        },
        VUE_APP_BASELINE_HEALTH_POLL_MS: {
            type: 'number',
            minimum: 1000,
            maximum: 600000,
            default: 15000
        },
        VUE_APP_DOCUMENT_GENERATOR_URL: {
            type: 'string',
            minLength: 8,
            maxLength: 128,
            default: 'https://pdfgen.dev1.glprotocol.com'
        },
        VUE_APP_API_3D_INTEGRATIONS: {
            type: 'string',
            minLength: 8,
            maxLength: 128,
            default: 'https://common.dev1.glprotocol.com/api-3d-integrations/'
        },
        VUE_APP_THEME: {
            type: 'string',
            maxLength: 128,
            default: 'default'
        },
        VUE_APP_BRAND_NAME: {
            type: 'string',
            maxLength: 128,
            default: 'Global Ledger'
        },
        // Empty means "use the bundled SVG"; otherwise an absolute http(s) URL,
        // a protocol-relative one (//cdn/...) or a path served by this app (/assets/...).
        // Keep the pattern permissive: env-schema throws on a mismatch, and appConfig is
        // imported by nearly every module, so a rejected value takes the whole app down.
        VUE_APP_BRAND_LOGO_URL: {
            type: 'string',
            maxLength: 512,
            pattern: '^((https?:)?//.+|/.+)?$',
            default: ''
        },
        VUE_APP_BRAND_LOGO_SHORT_URL: {
            type: 'string',
            maxLength: 512,
            pattern: '^((https?:)?//.+|/.+)?$',
            default: ''
        },
        VUE_APP_BRAND_FAVICON_URL: {
            type: 'string',
            maxLength: 512,
            pattern: '^((https?:)?//.+|/.+)?$',
            default: ''
        },
        VUE_APP_SCORING_FORMULA: {
            type: 'string',
            maxLength: 128,
            default: 'Series'
        },
        // Entries may carry an optional `symbol` (e.g. "$", "€", "Dh") that
        // overrides the built-in short-symbol map in utils/format-by-price.js.
        VUE_APP_FIAT_LIST: {
            type: 'string',
            default: '[{"key":"USD","label":"USD","symbol":"$"},{"key":"EUR","label":"EUR","symbol":"€"}]'
        },
        VUE_APP_ENTITY_PRIORITY: {
            type: 'string',
            default: '["owner", "entity"]',
        },
        VUE_APP_SCORE_REQUEST_DIRECTION: {
            type: 'number' ,
            default: 2
        },
        VUE_APP_DEFAULT_TOKEN: {
            type: 'string' ,
            default: 'supported'
        },
        VUE_APP_ESSENTIAL_API_URL: {
            type: 'string',
            minLength: 2,
            default: 'https://common.dev1.glprotocol.com/essential-api/'
        },
        VUE_APP_SHALLOW: {
            type: 'boolean' ,
            default: true
        },
        VUE_APP_PDF_TABLE_LIMIT: {
            type: 'number',
            default: 50
        },
        VUE_APP_API_USER_GUIDE_BASE_URL: {
            type: 'string',
            default: 'https://btc.dev5.glprotocol.com/api-guides/'
        },
        VUE_APP_USER_GUIDE_MAX_MB_PDF_FILE: {
            type: 'number',
            default: 50
        },
        VUE_APP_API_DOCUMENTATION_LINK: {
            type: 'string',
            default: 'https://common.glprotocol.com/api-doc/'
        },
        VUE_APP_DEFAULT_LAYOUT: {
            type: 'string',
            default: 'klay'
        },
        VUE_APP_DEFAULT_START_PAGE: {
            type: 'string',
            default: 'dashboard'
        },
        VUE_APP_RETRY_DELAYS_LIST: {
            type: 'array',
            default: [
                5000, 5000, 5000,
                10000, 10000, 10000,
                20000, 20000, 20000,
                30000,
                60000,
                90000,
                180000,
                300000
            ]
        },
        VUE_APP_FEATURE_UNIFIED_TOKEN: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_PERMISSION_MANAGER: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SELECTION_LAYOUTS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SELF_TRANSACTIONS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_MULTI_LABELING: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_FORMULA_SELECT: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_MULTIPLE_COIN: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SPEC_SYMBOLS_VALIDATE: {
            type: 'boolean' ,
            default: false
        },
        VUE_APP_FEATURE_USER_GUIDE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_PDF_GENERATOR: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ESSENTIAL_PDF_GENERATOR: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_SCREENING_PDF_GENERATOR: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_NY: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_START_POINT: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_VISION: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_VISION_ADVANCED_FILTERS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_VISION_COMMENTS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_VISION_ENTITY_LOGO: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ESSENTIAL: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_REPORT: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_REPORT_ALERTS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SCREENING: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_MONITORING: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_MY_CASES: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SCORE_REQUESTS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_COUNTERPARTY: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_COUNTERPARTY_ARCHIVE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_COUNTERPARTY_CUSTOM: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_COUNTERPARTY_FILTERS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_COUNTERPARTY_TX_LIST: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_BULK_ACTIONS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_BEHAVIOR: {
            type: 'boolean',
            default: true
        },
        VUE_APP_ALERTS_DISABLED_RULES: {
            type: 'string',
            separator: ',',
            default: ''
        },
        VUE_APP_FEATURE_ALERTS_SMART_FILTER: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_AI_SORT: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_AMOUNT_CUR_SHARE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_LOGIC_OPERATOR: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_UNHOSTED_TRIGGER: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_ALERTS_AMOUNT_CUR: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ALERTS_EXCLUDE_MULTI_DIRECTION: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_ALERTS_EMAIL_NOTIFICATIONS: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_PROFILE_EMAIL_NOTIFICATIONS: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_ALERTS_EXPORT_CSV: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_AUTO_TRACE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_ENTITY: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_SCORING_PROFILES: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_JIRA_INTEGRATION: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_INTEGRATIONS_CATALOG_MOCK: {
            type: 'boolean',
            default: false
        },
        VUE_APP_FEATURE_USER_ACTIVITY: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_USER_STATS: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_DEFI_EXPOSURE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_DEFI_PDF: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_FEATURES_ACCESS: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_BLOCKCHAIN_RECOGNITION: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_TX_TREE: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_TX_TREE_CP: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_TX_TREE_ESSENTIAL: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_AI_ASSESSMENT: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_COMPLIANCE_MEMORY: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_AI_BETA: {
          type: 'boolean',
          default: false
        },
        VUE_APP_FEATURE_TX_TREE_BTC_EXCLUDE: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_TX_ALL_ASSETS: {
          type: 'boolean',
          default: false
        },
        VUE_APP_FEATURE_PUBLIC_CASES: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_PM_FALLBACK: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_KYT_LAB: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_KYT_CSV_LIMIT: {
          type: 'number',
          default: 300,
        },
        VUE_APP_API_FILES_BASE_URL: {
          type: 'string',
          minLength: 2,
          default: 'https://common.dev1.glprotocol.com/api-files/'
        },
        VUE_APP_FEATURE_CASES_NEW: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_COPY_PASTE_ELEMENTS: {
          type: 'boolean',
          default: false
        },
        VUE_APP_FEATURE_MULTICHAIN: {
          type: 'boolean',
          default: false
        },
        VUE_APP_FEATURE_EDGE_GROUP_MODE: {
          type: 'string',
          default: 'contract'
        },
        VUE_APP_FEATURE_LABELING_ESSENTIAL: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_MFA_LOGIN_CODE: {
            type: 'boolean',
            default: true
        },
        VUE_APP_FEATURE_UNIFIED_ESSENTIAL_BASEURL: {
          type: 'boolean',
          default: true
        },
        VUE_APP_FEATURE_DASHBOARD: {
          type: 'boolean',
          default: true
        },
        // Deliberately not an `enum`: appConfig is imported app-wide, so rejecting an
        // unrecognised value here would turn a misspelled kill-switch into a boot failure
        // for the whole app. validate-payload falls back to 'off' instead.
        VUE_APP_PAYLOAD_VALIDATION: {
            type: 'string',
            description: 'off | warn | strict (anything else falls back to off)',
            default: 'warn'
        },
        VUE_APP_MANIFEST_KEYS: {
            type: 'string',
            default: null,
        },
        VUE_APP_ESSENTIAL_MANIFEST_KEYS: {
            type: 'string',
            default: null,
        },
        VUE_APP_LABELING_COINS: {
            type: 'string',
            default: null,
        },
    }
}

const config = envSchema({
    schema: schema,
    data: process.env, // optional, default: process.env
    dotenv: true // load .env if it is there, default: false
})

export default config
